import React, {Component} from 'react';
import {Steps, Upload, Spin, Form, Input,Alert } from 'antd';
import {modal, Button} from 'icsoc-antd-ex';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import actions from 'Actions/taskManage/list';
import {getCookie} from 'Utils'

import './index.less';

const {ModalSize} = modal;
const {Step} = Steps;
// const FormItem = Form.Item;
// const formItemLayout = {labelCol: {span: 5}, wrapperCol: {span: 19}};

class UploadModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current: 0, // 当前步骤
      loading: false, // 弹框底部按钮类型-'':null,'resetUpload':重新上传，'confirm':确认导入,'ok':确定
      fileList: [], // 上传文件列表
      failList: [], // 失败列表
      uploadData: {
        importId: undefined,
        failedNum: 0,
        dupNum: 0,
        successNum: 0,
        total: 0,
      }, // 上传数据
      errorMsg: null, // 错误信息ReactNode
      confirmLoading: false, // 确定按钮loading
      // batchName: '',
    };
  }

  // 文件上传之后
  uploadChange = info => {
    // if (info.file) {
    let {uploadData} = this.state;
    const {
      file: {
        status,
        response = {},
        response: {code = undefined, data = {}, msg = '上传失败'} = {},
      },
    } =
      info || {};
    // }
    if (data !== null) {
      const {total = 0, failed = [], dup = [], importId = undefined} = data;
      let fileList = [...info.fileList];
      // 失败数
      const failedNum =
        Array.isArray(failed) && failed.length > 0 ? failed.length : 0;
      // 重复数
      const dupNum = Array.isArray(dup) && dup.length > 0 ? dup.length : 0;
      // 成功数
      const successNum = total - failedNum - dupNum;
      const failList = failed.concat(dup);

      fileList = fileList.slice(-1); // 限制只能上传一个文件
      // 更新上传数据
      uploadData = {
        ...uploadData,
        importId,
        failedNum,
        dupNum,
        successNum,
        total,
      };

      this.setState(
        {
          fileList,
          loading: true,
          current: 1,
          failList,
          uploadData,
        },
        () => {
          if (status === 'done' && Object.keys(response).length !== 0) {
            this.setState({
              loading: false,
            });

            if (parseInt(code, 10) === 200) {
              this.handleResponseBack();
            } else {
              this.setState({
                fileList: [],
                footerType: 'resetUpload',
                errorMsg: <p>{msg}</p>,
              });
            }
          }
        },
      );
    } else {
      this.setState({
        loading: false,
        fileList: [],
        footerType: 'resetUpload',
        errorMsg: <p>{response.msg}</p>,
      });
    }
  };

  // 当上传之后接口返回200
  handleResponseBack = () => {
    const {
      uploadData: {failedNum, dupNum, total, successNum},
      failList,
    } = this.state;

    // 有错误数或者重复数
    if (failedNum || dupNum) {
      let footerType = 'confirm';
      let errorMsg = (
        <div>
          <p>
            共导入
            <span className="primary-color"> {total} </span>
            条数据，正确数据
            <span className="success-color"> {successNum} </span>
            条，错误数据
            <span className="error-color"> {failedNum} </span>
            条，重复数据
            <span className="error-color"> {dupNum} </span>
            条。
          </p>
          {Array.isArray(failList) && failList.length > 0
            ? failList.map(({name}, index) => <p key={index}>{name}。</p>)
            : null}
        </div>
      );

      // 若一条都没有成功
      if (successNum === 0) {
        footerType = 'resetUpload';
        errorMsg = <p>导入的表格无有效数据</p>;
      }

      this.setState({
        footerType,
        errorMsg,
      });
    } else {

      // 无错误数且无重复数
      this.onConfirm();
    }
  };

  // 确认上传
  onConfirm = () => {
    const {
      actions,
      id = undefined,
      form: {validateFields},
    } = this.props;
    validateFields((err, values) => {
      if (!err) {
        const {
          uploadData: {importId},
        } = this.state;
        const parmas = {
          taskId: id,
          importId,
          ...values,
        };
        this.setState({
          confirmLoading: true,
          loading: true,
        });
        actions
          .confirmUpload(parmas)
          .then(res => {
            const {payload: {code, msg = '导入失败'} = {}} = res || {};
            if (parseInt(code, 10) === 200) {
              this.setState({
                current: 1,
                footerType: 'ok',
                errorMsg: <p>导入成功</p>,
              });
            } else {
              this.setState({
                current: 1,
                footerType: 'confirm',
                errorMsg: <p>{msg}</p>,
              });
            }
          })
          .finally(() => {
            this.setState({
              confirmLoading: false,
              loading: false,
            });
          });
      } else {
        this.setState({
          current: 1,
          footerType: 'confirm',
          errorMsg: <p>请输入批次名</p>,
        });
      }
    });
  };

  afterClose = () => {
    const {form} = this.props;
    this.setState({
      current: 0,
      loading: false,
      footerType: '',
      fileList: [],
      failList: [],
      uploadData: {
        importId: undefined,
        failedNum: 0,
        dupNum: 0,
        successNum: 0,
        total: 0,
      },
      errorMsg: null,
      confirmLoading: false,
      // batchName: '',
    });
    // form.setFields({batchName: ''});
  };

  onCancel = () => {
    const {onCancel = () => {}, form} = this.props;
    // form.setFields({batchName: ''});

    onCancel();
  };

  render() {
    const {
      visible = false,
      onOk = () => {},
      // form: {getFieldDecorator},
    } = this.props;
    const {
      current,
      loading,
      footerType,
      fileList,
      errorMsg,
      confirmLoading,
      // batchName,
    } = this.state;
    const user = window.localStorage.getItem('user') || '{}';
    const authorization = JSON.parse(user).access_token || getCookie('ekt_access_token');
    let footerArr = null;
    if (footerType === 'resetUpload') {
      footerArr = [
        <Button type="primary" key="resetUpload" onClick={this.afterClose}>
          重新上传
        </Button>,
        <Button key="cancel" onClick={this.onCancel}>
          取消
        </Button>,
      ];
    }
    if (footerType === 'confirm') {
      footerArr = [
        <Button
          type="primary"
          key="confirm"
          onClick={this.onConfirm}
          loading={confirmLoading}>
          确认导入
        </Button>,
        <Button key="cancel" onClick={this.onCancel}>
          取消
        </Button>,
      ];
    }
    if (footerType === 'ok') {
      footerArr = [
        <Button type="primary" key="ok" onClick={onOk}>
          确定
        </Button>,
      ];
    }
    if (footerType === 'cancel') {
      footerArr = [
        <Button key="cancel" onClick={this.onCancel}>
          取消
        </Button>,
      ];
    }

    return (
      <ModalSize
        className="dataUpload"
        title="数据导入"
        centered
        maskClosable={false}
        visible={visible}
        onCancel={this.onCancel}
        footer={footerArr}
        afterClose={this.afterClose}
        width={500}>
        <Alert message="根据模板的格式填写需要导入的号码，上限50000条" type="warning" banner />
        <Steps current={current} labelPlacement="vertical">
          <Step title="上传文件" />
          <Step title="导入中" />
          <Step title="完成" />
        </Steps>
        {/* <Form
          style={{
            marginTop: '15px',
            width: '94%',
          }}>
          <FormItem {...formItemLayout} label="批次名称：">
            {getFieldDecorator('batchName', {
              initialValue: batchName,
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: '批次名称不得为空！',
                },
              ],
            })(<Input placeholder="请输入批次名称" />)}
          </FormItem>
        </Form> */}

        {current === 0 || current === 1 ? (
          <Spin spinning={loading}>
            <div
              className={`dataUpload-steps${current === 0 ? ' is-show' : ''}`}>
              <Upload
                name="file"
                action="/robot/file/importExcel"
                onChange={this.uploadChange}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                headers={{Authorization: `Bearer ${authorization}`}}
                fileList={fileList}>
                <Button>上传文件</Button>
              </Upload>
              <div style={{marginTop: 10}}>
                <a href="/robot/static/templates/template.xlsx">
                  <i className="iconfont_manager icon-robotdownload" />{' '}
                  下载导入模板
                </a>
              </div>
            </div>

            <div
              className={`dataUpload-steps${current === 1 ? ' is-show' : ''}`}>
              {errorMsg}
            </div>
          </Spin>
        ) : null}

        {current === 2 ? (
          <div className={`dataUpload-steps${current === 2 ? ' is-show' : ''}`}>
            {errorMsg}
          </div>
        ) : null}
      </ModalSize>
    );
  }
}

const mapStateToProps = state => {
  return {
    taskdetail: state.taskdetail,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};
const UploadModalWrap = Form.create()(UploadModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UploadModalWrap);
